import React from 'react'
import { Icon } from '../Icon'

interface UIRadiobuttonProps {
  label?: string
  desc?: string
  checked: boolean
  onChange: () => void
}

const UIRadiobutton: React.FC<UIRadiobuttonProps> = ({
  label,
  desc,
  checked = false,
  onChange,
}) => {
  return (
    <div className="rounded-xl p-3 bg-gray1">
      <div className="flex">
        <p className="text-sm font-semibold leading-6 text-text4 flex-1">
          {label}
        </p>
        <div onClick={onChange} className="cursor-pointer">
          <Icon
            name={checked ? 'IconRadio' : 'IconCircle'}
            stroke="#99C3D1"
            width={16}
            height={16}
            strokeWidth={1.5}
          />
        </div>
      </div>
      {desc && (
        <p className="text-sm font-normal leading-6 text-text1">{desc}</p>
      )}
    </div>
  )
}

export default UIRadiobutton
